module.exports = __webpack_public_path__ + "images/category_lp/camera/new/main-bg_a8d6f9038540580ab4d026fdfbee9c35.png";